import { useTranslation } from 'react-i18next'
import { useAppDispatch } from '../../../app/store/hooks/Redux'
import { BpButton } from '../../../shared/components/buttons/bp-button/BpButton'
import { hideModal } from '../../../app/store/reducers/AppSlice'
import React from 'react'
import { BpInput } from '../../../shared/components/forms/input/BpInput'
import { BpSelect } from '../../../shared/components/forms/select/BpSelect'
import { useGetFilterCountryQuery, usePostTrademarkRegistrationAddMutation } from '../../../app/api'
import { useForm } from 'react-hook-form'
import { renderCountryOption } from '../../../shared/components/utility/country-option/CountryOption'

interface AddTrademarkRegistrationModalProps {
  data: {
    project_id: number
    trademark_id: number
    country_id?: number
  }
}

export const AddTrademarkRegistrationModal = ({ data }: AddTrademarkRegistrationModalProps) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  const [addRegistration, { isLoading }] = usePostTrademarkRegistrationAddMutation()
  const { data: countries } = useGetFilterCountryQuery({})

  const {
    handleSubmit,
    register,
    formState: { isValid },
  } = useForm({
    mode: 'onChange',
  })

  const submit = (values: any) => {
    addRegistration({
      body: {
        project_id: data.project_id,
        trademark_id: data.trademark_id,
        ...values,
        ...(data.country_id && { country_id: data.country_id }),
      },
    }).then(() => {
      dispatch(hideModal())
    })
  }

  return (
    <form className={'flex flex-col'} onSubmit={handleSubmit(submit)}>
      <h3
        className={
          'flex min-h-[55px] w-full items-center border-b-[3px] border-b-[#00326D]/[.02] px-[24px] text-[20px] font-medium'
        }
      >
        {t('components.addTrademarkRegistrationModal.newRegistration')}
      </h3>
      <div className={'flex flex-col gap-[16px] px-[24px] pt-[18px] pb-[16px]'}>
        <BpSelect
          required
          defaultValue={String(data.country_id || '')}
          disabled={!!data.country_id}
          dropPosition={'auto'}
          label={t('fields.country')}
          optionRender={renderCountryOption}
          options={countries}
          placeholder={t('fields.selectCountry')}
          {...register('country_id', {
            required: data.country_id ? false : t('fields.validate.required'),
          })}
        />
        <BpInput
          required
          label={t('fields.registrationNumber')}
          placeholder={t('fields.egRegistrationNumber')}
          {...register('registration_number', { required: t('fields.validate.required') })}
        />
      </div>
      <div
        className={
          'flex w-full gap-[12px] border-t-[3px] border-t-[#00326D]/[.02] px-[24px] py-[24px]'
        }
      >
        <BpButton className={'uppercase'} disabled={!isValid || isLoading} type={'submit'}>
          {t('buttons.add')}
        </BpButton>
        <BpButton
          disabled={isLoading}
          theme='transparent'
          type='button'
          onClick={() => dispatch(hideModal())}
        >
          {t('buttons.cancel')}
        </BpButton>
      </div>
    </form>
  )
}
